import { useCallback, useEffect, useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AnimatePresence } from "framer-motion";
import Lenis from "lenis";
import { Toaster } from "sonner";
import Intro from "@/components/Intro";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import PageMeta from "@/components/PageMeta";
import Home from "@/pages/Home";
import Games from "@/pages/Games";
import Plugins from "@/pages/Plugins";
import Projects from "@/pages/Projects";
import AddonDetail from "@/pages/AddonDetail";
import Services from "@/pages/Services";
import CaseStudy from "@/pages/CaseStudy";
import GameDetail from "@/pages/GameDetail";
import About from "@/pages/About";
import Kronix from "@/pages/Kronix";
import Journal from "@/pages/Journal";
import Article from "@/pages/Article";
import Contact from "@/pages/Contact";
import ArsenalHub from "@/pages/ArsenalHub";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

function App() {
  const [introDone, setIntroDone] = useState(() => {
    try {
      return sessionStorage.getItem("af-intro") === "1";
    } catch {
      return false;
    }
  });

  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  const completeIntro = useCallback(() => {
    try {
      sessionStorage.setItem("af-intro", "1");
    } catch {
      /* ignore */
    }
    setIntroDone(true);
  }, []);

  return (
    <div className="App bg-[#0A0B0D] text-[#F4F5F7]">
      <BrowserRouter>
        <ScrollToTop />
        <PageMeta />
        <AnimatePresence>
          {!introDone && <Intro onComplete={completeIntro} />}
        </AnimatePresence>
        <Navbar />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/games" element={<Games />} />
            <Route path="/projects" element={<Projects />} />
            <Route path="/projects/:slug" element={<AddonDetail />} />
            <Route path="/downloads/wow" element={<Navigate to="/projects" replace />} />
            <Route path="/downloads/wow/arsenal-hub" element={<ArsenalHub />} />
            <Route path="/services" element={<Services />} />
            <Route path="/case-studies/:slug" element={<CaseStudy />} />
            <Route path="/plugins" element={<Plugins />} />
            <Route path="/games/territoria" element={<GameDetail />} />
            <Route path="/games/kronix" element={<Kronix />} />
            <Route path="/about" element={<About />} />
            <Route path="/journal" element={<Journal />} />
            <Route path="/journal/:slug" element={<Article />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="*" element={<Home />} />
          </Routes>
        </main>
        <Footer />
      </BrowserRouter>
      <Toaster theme="dark" position="bottom-right" />
    </div>
  );
}

export default App;
